import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild } from '@angular/core';
import * as Plotly from 'plotly.js';
declare global {
  interface Window {
    Plotly: typeof Plotly;
  }
}
@Component({
  selector: 'app-plotly-sunburst',
  templateUrl: './plotly-sunburst.component.html',
  styleUrls: ['./plotly-sunburst.component.css']
})
export class PlotlySunburstComponent implements OnInit {
  @ViewChild("sunburst", { static: true }) private sunburst: ElementRef<HTMLElement>;
  @Input() sunburstData: any;
  // @Input() index:any;
  @Output() sunBurstAction = new EventEmitter<any>();
  ngOnInit(): void { }

  ngOnChanges(){  
    if(this.sunburstData.length)
    setTimeout(() => {
    this._plotGraph();  
    },0);
  } 

  private _plotGraph(){

    // this.className = 'donut'+ JSON.stringify(this.index);
    window.Plotly.newPlot( 
      'sunburst',
      // this.sunburst.nativeElement, //viewchild element
      this.sunburstData, //data provided
      {
        "margin": {"l": 0, "r": 0, "b": 0, "t": 0},
        height: 250,
        colorway: this.sunburstData[0].sunburstcolorway,
      width: this.sunburstData[0].width?this.sunburstData[0].width: 300,
      },
      {displaylogo: false,
      displayModeBar: false,
      showSendToCloud: true});
      (document.getElementById('sunburst') as any).on('plotly_click', (data:any)=>{
        this.sunBurstAction.emit(data);
      });
  }
}

